/**
 * ps/modal - Modal generator for Bootstrap 3.3.x modals and Revox Pages classes
 *
 * To create a classic modal:
 * modal.create(settings) :
 *      @input settings {object} // see code | most important :
 *          settings.modalType {string} // slide-up | fill-in | slide-right | stick-up
 *          settings.modalId {string} // your modalId or will be generated as modal-[RandomId]
 *          settings.title {string} // modal Title
 *          settings.body {var} // will apend to modal-body
 *
 *      @output DOM Model Object with Id
 *
 *  To create a iframe modal :
 *  modal.iframe(src, settings)
 *      @input src, settings :
 *          src -> path or resource to load in modal.body
 *          settings -> the same as with normal modal (see below)
 *      @output DOM Model Object with Id
 *
 *  Others:
 *  modal.confirm -> confirm dialog modal
 *  modal.alert -> alert dialog modal
 *  modal.messageError -> just Error modal
 *  modal.messageSuccess -> just Success modal
 *  modal.messageWarning -> just Warning modal
 */

define(['jquery', 'bootstrap'], function($) {
    var modal = {
        _currentModal: null,
        _openedModals: 0,

        _buildModal: function(settings) {
            // Star Vars
            if((settings.modalType == 'default') || (settings.modalType == undefined)) settings.modalType = 'slide-up';
            if(settings.modalId == undefined) settings.modalId = 'modal-'+Math.round(Math.random() * 10000000);
            if(settings.mapModal == undefined) settings.mapModal = false;

            // DOM elements
            var $div = $('<div />',{
                    'id': settings.modalId,
                    'class': 'modal '+settings.modalType,
                    'role': 'dialog',
                    'tabindex': -1,
                    'aria-labelledby': 'modalSlideUpLabel',
                    'aria-hidden': true
                }),

                $divDialog = $('<div />',{
                    'class': 'modal-dialog'
                }),
                $divContent = $('<div />',{
                    'class': 'modal-content'
                }),
                $divWrapper = $('<div />' , {
                    'class': 'modal-content-wrapper'
                }),
                $header = $('<div />' , {
                    'class': 'modal-header clearfix text-left'
                }),
                $body = $('<div />' , {
                    'class': 'modal-body'
                }),
                $footer = $('<div />' , {
                    'class': 'modal-footer'
                }),
                $buttonClose = $('<button />', {
                    'type': 'button',
                    'class': 'close',
                    'data-dismiss': 'modal',
                    'aria-hidden': 'true',
                    'html': '<i class="fa fa-times"></i>'
                    //'html': '<i class="pg-close"></i>'
                });

            // switch some DOM it for fill-in, god only knows why they dont do this using stylezz
            if(settings.modalType == 'fill-in') {
                $divWrapper = $('<div />' , {
                    'class': 'modal-content'
                });
                $divContent = $('<div />' , {
                    'class': 'modal-content-wrapper'
                });
            }

            // main modal // dialog  options
            typeof settings.modalClass == 'string' ? $div.addClass(settings.modalClass) : $div.addClass('fade');
            if(settings.dialogClass) $divDialog.addClass(settings.dialogClass);



            // Clear modala po zamknieciu
            $div.modal(settings)
                .on('hide.bs.modal', function() {
                    modal._currentModal = null;
                    $('.modal-backdrop', $div).removeClass('in');
                    var $modal = $(this);
                    setTimeout(function() {
                        $('.modal-backdrop', $div).remove();
                        $modal.remove();
                        modal._openedModals--;
                        if(modal._openedModals > 0) {
                            $('body').addClass('modal-open');
                        } else {
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    },200);
                }).on('shown.bs.modal', function() {
                    modal._openedModals++;
                });

            // Title + close button
            // close button w/options
            var buttonCloseHidden = false;
            if(settings.buttonCloseHidden) buttonCloseHidden = settings.buttonCloseHidden;
            if(buttonCloseHidden != false) $buttonClose = false;

            if(settings.modalType == 'fill-in')  $div.append($buttonClose);
            // if setting.title is set add Header title
            if(typeof settings.title == 'string' && settings.title.length > 0) {
                var $title = $('<h4>', {
                    'class': 'modal-title',
                    'html' : settings.title
                });
                // if slide-right (close in other place)
                if(($buttonClose) && (settings.modalType != 'fill-in')) {
                    if(settings.modalType == "slide-right") $buttonClose.css({position: 'absolute', top: '29px', right: '12px'});
                    $header.append($buttonClose);
                }
                $header.append($title);
                $divContent.prepend($header);
            } else {
                if(($buttonClose) && (settings.modalType != 'fill-in')) {
                    $divContent.prepend($buttonClose);
                }
            }

            // body
            if(settings.body) {
                $body.append(settings.body);
                $divContent.append($body);
            }

            // footer w/buttons
            if(settings.buttons instanceof Array) {
                for(x in settings.buttons) {
                    if(settings.buttons.hasOwnProperty(x)) {
                        var config = settings.buttons[x];
                        var $button = $('<a />', {'class':'btn'});
                        if(config['class']) $button.addClass(config['class']);
                        if(config.label) $button.html(config.label);
                        if(config.click) $button.click(config.click);
                        $footer.append($button);
                    }
                }
            } else {
                // footer wo/buttons
                if(settings.footer) $footer.append(settings.footer);
            }
            $divContent.append($footer);

            // width x height if set
            if(settings.width) $divDialog.width(settings.width + 'px');
            if(settings.height) $divDialog.height(settings.height + 'px');
            // height for slide and fill must be 100%
            if(settings.modalType == 'fill-in' || settings.modalType == 'slide-right') $divDialog.height('100%');

            if (settings.modalType == 'fill-in' && settings.modalGallery == true) {
                $divDialog.width(settings.width + 'px');
                $divDialog.height(settings.height + 'px');
            }

            // build all parts together
            $divWrapper.append($divContent);
            $divDialog.append($divWrapper);
            $div.append($divDialog);

            // append to body
            $('body').append($div);
            setTimeout(function(){
                $('.modal-backdrop', $div).addClass('in');
            }, 1);

            $div.on('touchstart', function() {
                var top = this.scrollTop;
                var totalScroll = this.scrollHeight;
                var currentScroll = top + this.offsetHeight;

                if ( top <= 0 ) {
                    $(this).scrollTop(1);
                } else if ( currentScroll >= totalScroll ) {
                    $(this).scrollTop(top -1);
                }
            });

            // zapamiętuje aktualnie wyświetlany dialog
            modal._currentModal = $div;
            return $div;
        },

        /**
         * Tworzy nowy modal.
         * @param array options (all optional)
         *      settings.modalType = slide-up || stick-up || slide-right || fill-in (@DEF: slide-up if 'default'||undefined)
         *      settings.modalId = some id, will be created if not set
         *      settings.title = String
         * @return jQuery Element DIV do którego wstawiono modal.
         */
        create: function(settings) {
            return this._buildModal(settings);
        },

        /**
         * Tworzy i automatycznie wyświetla modal z Mapą
         * @input
         *      element {DOM Object} // znacznika trzymajacego data-lng && data-lat
         *      options {object} // jak w normalnym modal.create + dodatkowe opcje mapy:
         *          mapModal {boolean} // true - flaga
         *          mapHeight {string} // wysokosc mapy (@def : 500px)
         *          mapWidth {string} // szerokosc mapy (@def : 100%)
         *          mapLat: {Float/String} // Latitude
         *          mapLng: {Float/String} // Longitude
         *          mapOptions : {object} // jak w dokumentacji google Maps Api
         * @output  {jQuery DOM Element DIV} z mapą
         */

        map: function(element, options){
            if(options == undefined) options = {};
            var defaults = {
                modalClass: 'disable-scroll fade',
                modalType: 'slide-up',
                dialogClass: 'modal-dialog',
                title: 'Zobacz na mapie',
                backdrop: true,
                keyboard: false,
                buttons: [
                {
                    label: 'Zamknij',
                    'class': 'btn button-modal-action',
                    click: function(e) {
                        e.preventDefault();
                        $(this).closest('.modal').modal('hide');
                        if(typeof callback == 'function') {
                            callback(false);
                        }
                    }
                }],
                mapModal : true,
                mapHeight: "500px",
                mapWidth: "100%",
                mapLat: parseFloat(element[0].dataset.lat),
                mapLng: parseFloat(element[0].dataset.lng),
                mapId: 'modal-map-'+Math.round(Math.random() * 100),
                mapOptions : {
                    zoom: 16,
                    scrollwheel: false,
                    zoomControl: true,
                    panControl: false,
                    scaleControl: false
                }
            };
            options = $.extend({}, defaults, options);

            options.body = $('<div />',{
                'id': options.mapId,
                'width': options.mapWidth,
                'height': options.mapHeight
            });

            return modal.create(options);
        },

        /**
         * Tworzy i automatycznie wyświetla modal CONFIRM.
         *
         * @param string message Wiadomość do wyświetlenia.
         * @param function callback Funkcja do uruchomienia po otrzymaniu odpowiedzi od użytkownika.
         *                            Funkcja przyjmuje parametr confirmed [true/false].
         * @param array options
         * @return jQuery Element DIV do którego wstawiono modal.
         */
        confirm: function(message, callback, options) {
            var defaults = {
                modalClass: 'slide-up disable-scroll fade modal-confirm',
                dialogClass: 'modal-dialog',
                title: 'Potwierdzenie',
                body: message,
                backdrop: 'static',
                keyboard: false,
                buttonCloseHidden: true,
                buttons: [{
                    label: 'OK',
                    'class': 'btn button-modal-action',
                    click: function(e) {
                        e.preventDefault();
                        $(this).closest('.modal').modal('hide');
                        if(typeof callback == 'function') {
                            callback(true);
                        }
                    }
                },
                {
                    label: 'Anuluj',
                    'class': 'btn button-modal-cancel',
                    click: function(e) {
                        e.preventDefault();
                        $(this).closest('.modal').modal('hide');
                        if(typeof callback == 'function') {
                            callback(false);
                        }
                    }
                }]
            };

            return modal.create($.extend({}, defaults, options));
        },


        /**
         * Tworzy i automatycznie wyświetla dialog ALERT.
         *
         * @param string message Wiadomość do wyświetlenia.
         * @param function callback Funkcja do uruchomienia po kliknięciu przycisku OK.
         * @param object options
         * @return null|jQuery Element DIV do którego wstawiono dialog albo NULL w przypadku gdy wyświetlono zwykły alert().
         */
        alert: function(message, callback, options) {
            // jeśli mamy alert wewnątrz IFRAME to wyświetlamy standardową wiadomość
            if(parent.location != window.location) {
                // usuwa HTML i wyświetla wiadomość tekstową
                return alert(message.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, ''));
            }

            var defaults = {
                modalClass: 'slide-up disable-scroll fade',
                dialogClass: 'modal-dialog',
                backdrop: 'static',
                show: true,
                buttonCloseHidden: true,
                title: 'Komunikat',
                body: message,
                footer: '<button class="btn button-modal-action" data-dismiss="modal">OK</button>'
            };

            return modal.create($.extend({}, defaults, options));
        },

        /**
         * Tworzy i automatycznie wyświetla dialog z wiadomością o błędzie | sukcesie | Ostrzeżeniu.
         * Po kliknięciu w przycisk OK, zamyka dialog.
         *
         * @param {string} message Wiadomość do wyświetlenia.
         * @param {object} options
         * @return {null|jQuery} Element DIV do którego wstawiono dialog albo NULL w przypadku gdy wyświetlono zwykły alert().
         */
        messageError: function(message, options) {
            var defaults = {
                modalClass: 'slide-up disable-scroll fade modal-error',
                title: 'Wystąpił błąd',
            };
            return modal.alert(message, null, $.extend({}, defaults, options));
        },

        messageSuccess: function(message, options) {
            var defaults = {
                modalClass: 'slide-up disable-scroll fade modal-success',
                title: 'Komunikat'
            };
            return modal.alert(message, null, $.extend({}, defaults, options));
        },

        messageWarning: function(message, options) {
            var defaults = {
                modalClass: 'slide-up disable-scroll fade modal-warning',
                title: 'Ostrzeżenie',
            };
            return modal.alert(message, null, $.extend({}, defaults, options));
        },

        /**
         * Wyświetla okienko dialog z treścią pobraną z zewnętrznego dokumentu HTML
         * i załadowaną do IFRAME.
         *
         * @param string src Adres URL do dokumentu.
         * @param array options Dodatkowe opcje dla modala.
         * @return null|jQuery Element DIV do którego wstawiono dialog albo NULL w przypadku gdy wyświetlono zwykły alert().
         */
        iframe: function(src, options) {
            var $divLoading = $('<div />',{
                'class': 'progress-circle-indeterminate'
            });

            if(options==undefined) options = {};

            var defaults = {
                width: '100%',
                height: false,
                body: $divLoading,
                backdrop: true,
                keyboard: false,
                show: true,
                modalType: 'slide-up iframe',
            };

            var options = $.extend({}, defaults, options);

            if(options.modalType=='slide-right') {
                defaults.height = '100%';
            }

            var $divDialog = modal.create(options);

            var $iframe = $('<iframe />');

            var $modal = $('<div class="modal" />');
            $iframe.width(defaults.width)
                .attr('frameborder', '0')
                .css('border', '0');

            if(options.modalType == 'fill-in') {
                $iframe.hide();
            }

            var iframeDidEndLoading = function() {
                $iframe.height($divDialog.find('.modal-content').height());
                $divLoading.remove();
                $divDialog.find('.modal-body').removeClass('loading');
                $iframe.show();

                setTimeout(function(){
                    var height = $iframe.contents().find('.iframe-content').outerHeight();
                    var maxHeight = $(window).height() - 160;

                    if(height > maxHeight) {
                        height = maxHeight;
                    }

                    $iframe.animate({height: height}, 500);
                },200);
            };

            src.indexOf('?') == -1 ? src += '?iframe=true' :  src += '&iframe=true';

            $iframe.hide();
            $iframe.attr('src', src).load(iframeDidEndLoading);

            $divDialog.find('.modal-body')
                .addClass('iframe')
                .addClass('loading')
                .append($iframe);

            return $divDialog;
        }

    }; // .modal

    return modal;
});